import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchGroupDetail = createAsyncThunk("fetchGroupDetail", async (id, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.get(`/groups/${id}`);
		const data = response?.data?.data;

		return data?.group || data;
	} catch (error) {
		return rejectWithValue(error?.response?.data?.message || "Failed to load group details");
	}
});

const GroupDetailSlice = createSlice({
	name: "GroupDetailSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	reducers: {
		resetGroupDetail: (state) => {
			state.isLoading = false;
			state.data = null;
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchGroupDetail.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});

		builder.addCase(fetchGroupDetail.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(fetchGroupDetail.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
			state.data = null;
		});
	},
});

export const { resetGroupDetail } = GroupDetailSlice.actions;

export default GroupDetailSlice.reducer;
